export default function NotificationIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="notification-icon"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 20}
      height={height ? height : width ? width : 20}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="M8.8 38.6q-.85 0-1.425-.575Q6.8 37.45 6.8 36.6q0-.85.575-1.4.575-.55 1.425-.55h2.45V20.1q0-4.35 2.575-7.925T20.7 7.65v-1.3q0-1.35.975-2.25.975-.9 2.325-.9t2.325.9q.975.9.975 2.25v1.3q4.3.95 6.925 4.525T36.85 20.1v14.55h2.4q.8 0 1.4.575.6.575.6 1.425 0 .85-.6 1.4-.6.55-1.4.55ZM24 23.3Zm0 21.4q-1.7 0-2.975-1.25-1.275-1.25-1.275-2.95h8.5q0 1.75-1.25 2.975T24 44.7Zm-8.8-10.05h17.65V20.1q0-3.75-2.525-6.325T24.1 11.2q-3.75 0-6.325 2.575T15.2 20.1Z"
      />
    </svg>
  );
}
